// Must match SessionTokenPolicy in Security and Productores. This is UI validation, not signature verification.
export const SESSION_VERSION = '3';
const scalar = value => typeof value === 'string' || typeof value === 'number';
export const isCurrentSession = (claims, validFromUtc = import.meta.env.VITE_SESSIONS_VALID_FROM_UTC) => {
  const cutoff = validFromUtc ? Date.parse(validFromUtc) : 0;
  return ['permission_model', 'session_version', 'accountType', 'auth_time', 'exp'].every(key => scalar(claims?.[key]))
    && String(claims.permission_model) === '1' && String(claims.session_version) === SESSION_VERSION
    && ['1', '2'].includes(String(claims?.accountType))
    && typeof claims?.id === 'string' && claims.id.trim().length > 0
    && /^\d+$/.test(String(claims.auth_time)) && Number.isSafeInteger(Number(claims.auth_time)) && Number(claims.auth_time) > 0
    && Number(claims.auth_time) * 1000 <= Date.now()
    && Number.isFinite(cutoff) && Number(claims.auth_time) >= Math.floor(cutoff / 1000)
    && Number.isFinite(Number(claims.exp)) && Number(claims.exp) > 0;
};
